import React, { useState, useEffect, useRef } from 'react';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';

interface KontoInputProps {
  value: string;
  onChange: (konto: string, naziv?: string) => void;
  placeholder?: string;
  className?: string;
  companyId?: string;
}

export function KontoInput({ value, onChange, placeholder = '160000', className = '', companyId }: KontoInputProps) {
  const { selectedCompany } = useAuthStore();
  const effectiveCompanyId = companyId || selectedCompany?.id || '';
  const [konti, setKonti] = useState<any[]>([]);
  const [query, setQuery] = useState(value || '');
  const [open, setOpen] = useState(false);
  const [filtered, setFiltered] = useState<any[]>([]);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (effectiveCompanyId) {
      api.get(`/sifranti/kontni-plan/${effectiveCompanyId}`)
        .then(r => { console.log('Konti loaded:', r.data?.length, 'companyId:', effectiveCompanyId); setKonti(r.data || []); })
        .catch(e => console.error('Konti error:', e));
    }
  }, [effectiveCompanyId]);

  useEffect(() => {
    setQuery(value || '');
  }, [value]);

  useEffect(() => {
    console.log('FILTER CHECK:', query, query.length, konti.length); if (!query || query.length < 2) { setFiltered([]); return; }
    const q = query.toLowerCase();
    console.log('Filtering:', query, 'konti:', konti.length);
    setFiltered(
      konti.filter(k =>
        k.code?.toLowerCase().includes(q) ||
        k.name?.toLowerCase().includes(q)
      ).slice(0, 10)
    );
  }, [query, konti]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <input
        value={query}
        onChange={e => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => { setQuery(''); setOpen(true); }}
        onBlur={() => { setTimeout(() => { setQuery(value || ''); }, 200); }}
        placeholder={placeholder}
        className={`w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition font-mono ${className}`}
      />
      {open && filtered.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg max-h-48 overflow-y-auto">
          {filtered.map((k, idx) => (
            <button
              key={k.code || k.account_code || idx}
              onMouseDown={() => {
                setQuery(k.code);
                onChange(k.code, k.name);
                setOpen(false);
              }}
              className="w-full px-3 py-2 text-left text-sm hover:bg-blue-50 dark:hover:bg-gray-700 flex gap-3"
            >
              <span className="font-mono font-bold text-blue-600 dark:text-blue-400 w-16 shrink-0">{k.code}</span>
              <span className="text-gray-600 dark:text-gray-300 truncate">{k.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
